import { Route, Routes } from "react-router-dom";
import { PTLI0205001S } from "@/tra/tancis/ptli/acrdt/newusr/PTLI0205001S";
import { PTLI0205002Q } from "../acrdt/newusr/PTLI0205002Q";
import { PTLI0205003Q } from "../acrdt/newusr/PTLI0205003Q";
import { PTLI0204001S } from "../acrdt/lgn/PTLI0204001S";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */
export const AcrdtRouter = () => {
    return (
        <Routes>
            {/** ==================== Password Change Router START ==================== */}

            {/* Password Change !== 비밀번호 변경 ==! */}
            <Route path={"/lgn/ptli0204001s/:usrDmnId"} element={<PTLI0204001S />} />

            {/** ====================  Password Change Router END ==================== */}

            {/** ==================== Apply for User Registration START ==================== */}

            {/* Check user registration application information !== 사용자 등록 신청 정보 조회 ==! */}
            <Route path={"/newusr/ptli0205001s/:usrDmnId"} element={<PTLI0205001S />} />
            <Route path={"/newusr/ptli0205002q"} element={<PTLI0205002Q />} />
            <Route path={"/newusr/ptli0205003q"} element={<PTLI0205003Q />} />

            {/** ==================== Apply for User Registration END ==================== */}
        </Routes>
    );
};
